import React from 'react';
import '../../styles/pagination/pagination.css';
import { Icon } from '@iconify/react/dist/iconify.js';

const Pagination = ({
    currentPage,
    totalItems,
    entriesPerPage,
    onPageChange,
    className = '',
    hideNavigation = false
  }) => {
    const totalPages = Math.ceil(totalItems / entriesPerPage);
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;

  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    const maxPagesToShow = 7;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - delta);
      let endPage = Math.min(totalPages, currentPage + delta);

      if (currentPage <= delta + 1) {
        startPage = 1;
        endPage = Math.min(maxPagesToShow - 1, totalPages);
      } else if (currentPage + delta >= totalPages) {
        startPage = Math.max(1, totalPages - maxPagesToShow + 2);
        endPage = totalPages;
      
    }

    for (let i = startPage; i <= endPage; i++) {
      range.push(i);
    }

    if (startPage > 1) {
      range.unshift(1); 
      if (startPage > 2) {
        range.splice(1, 0, '...'); // Add ellipsis after page 1
      }
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        range.push('...'); 
      }
      range.push(totalPages);
    }
    }
    

    return range;
  };

  const renderEntriesInfo = () => {
    if (totalItems === 0) return 'Showing 0 entries';
    
    const start = indexOfFirstEntry + 1;
    const end = Math.min(indexOfLastEntry, totalItems);
    return (
      <>
        Showing {' '}
        <span>
          {start} to {end} of {totalItems}
        </span>{' '}
        entries
      </>
    );
  };
  
    return (
      <div className={`pagination-controls ${className}`}>
        <div className="entries-info">
          {renderEntriesInfo()}
        </div>
        {!hideNavigation && (
          <div className="pagination">
            <button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-arrow"
            >
              <Icon icon="iconamoon:arrow-left-2-light" width="24" height="24" />
            </button>

            {getPageNumbers().map((pageNum, index) => (
              <button
                key={index}
                onClick={() => typeof pageNum === 'number' ? onPageChange(pageNum) : null}
                className={`pagination-button ${
                  currentPage === pageNum ? 'active' : ''
                } ${typeof pageNum !== 'number' ? 'dots' : ''}`}
                disabled={typeof pageNum !== 'number'}
              >
                {pageNum}
              </button>
            ))}

            <button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-arrow"
            >
              <Icon icon="iconamoon:arrow-right-2-light" width="24" height="24"/>
            </button>
          </div>
        )}
      </div>
    );
  };
  

export default Pagination